// Central data-testid registry
export const TID = {
    nav: "top-navigation",
    langToggle: "lang-toggle",
    modeToggle: "mode-toggle",
    pdfButton: "pdf-button",
    indexButton: "index-button",
    indexPanel: "chapter-index-panel",
    indexItem: (slug) => `index-item-${slug}`,
    cover: "chapter-cover",
    opening: "chapter-opening",
    chapter: (slug) => `chapter-${slug}`,
    heroLogo: "hero-logo-lockup",
    mirrorHero: "mirror-hero-monolith",
    marquee: "editorial-marquee",
    contactForm: "distributor-form",
    formName: "form-name",
    formEmail: "form-email",
    formCompany: "form-company",
    formCountry: "form-country",
    formCategory: "form-category",
    formMessage: "form-message",
    formSubmit: "form-submit",
    formStatus: "form-status",
    flipbookNext: "flipbook-next",
    flipbookPrev: "flipbook-prev",
    flipbookCounter: "flipbook-counter",
    progressBar: "chapter-progress-bar",
    beginScroll: "cover-begin-scroll",
    beginPresentation: "cover-begin-presentation",
};
